const emojis = {
  wave: ['👋', '✨', '💫'],
  health: ['💪', '🏃‍♂️', '🧘‍♂️'],
  data: ['📊', '📈', '💡'],
  support: ['🌟', '✨', '💫'],
  heart: ['💖', '💝', '💕']
};

const intros = [
  "Hi! I'm Drogo",
  "Hey! Drogo here",
  "Hello! I'm Drogo",
  "Greetings! I'm Drogo"
];

const roles = [
  "your AI Health Coach",
  "your personal wellness companion",
  "your fitness journey partner",
  "your health and wellness guide"
];

const offers = [
  "I'm here to help optimize your wellness journey",
  "I'm ready to support your health and fitness goals",
  "I'm here to guide you towards your wellness objectives",
  "I'm excited to help you achieve your health goals"
];

const dataPoints = [
  "using your personal metrics and data",
  "based on your health metrics and patterns",
  "analyzing your performance data",
  "leveraging your wellness insights"
];

const invitations = [
  "Feel free to ask me anything about your health and fitness!",
  "Ask me anything about your wellness journey!",
  "What would you like to know about your health today?",
  "How can I help optimize your wellness today?"
];

export function getRandomWelcomeMessage(): string {
  const getRandomItem = <T>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
  const getRandomEmoji = (type: keyof typeof emojis): string => getRandomItem(emojis[type]);

  return [
    `${getRandomItem(intros)} ${getRandomEmoji('wave')}`,
    `${getRandomItem(roles)} ${getRandomEmoji('health')}`,
    `\n${getRandomItem(offers)} ${getRandomEmoji('data')} ${getRandomItem(dataPoints)}`,
    `\n${getRandomItem(invitations)} ${getRandomEmoji('heart')}`
  ].join('\n');
}